import { render, staticRenderFns } from "./ScheduleMonthsSwitch.vue?vue&type=template&id=8df4b97a"
import script from "./ScheduleMonthsSwitch.vue?vue&type=script&lang=js"
export * from "./ScheduleMonthsSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports